/*
 * Copyright (c) 2025, Gather
 * https://gather.life
 */

import { ListItem as MuiListItem, ListItemAvatar, ListItemText } from '@mui/material';
import { memo, type ReactNode } from 'react';

import type { ListItemProps } from './list-item.interface';

const ListItem = ({
  avatar,
  primary,
  secondary,
  action,
  disableTypography,
  ...props
}: ListItemProps): ReactNode => {
  return (
    <MuiListItem {...props}>
      {avatar && <ListItemAvatar>{avatar}</ListItemAvatar>}
      <ListItemText disableTypography={disableTypography} primary={primary} secondary={secondary} />
      {action}
    </MuiListItem>
  );
};

export default memo(ListItem);
